import { useLayoutEffect } from 'react';
import { useHistory } from 'react-router-dom';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { mountPoint } from 'utils/generic/route-manipulation';

export const useSportsbookMountPoint = (): void => {
  const history = useHistory();

  useLayoutEffect(() => {
    if (SpringConfigs.MOCKED_DATA) {
      return;
    }

    const [shouldRedirect, redirectPath] = mountPoint(
      location.pathname,
      true,
      false
    );

    if (shouldRedirect && typeof redirectPath === 'string') {
      history.push(`${redirectPath}${window.location.search}` as string);
    }
  }, []);
};
